import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SettingService } from 'src/app/applicationModules/settings/services/settingService/setting.service';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import * as jwt_decode from 'jwt-decode';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { ToastrService } from 'ngx-toastr';
const FileSaver = require('file-saver');
import * as moment from 'moment';
import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';
import { HTMLFormSignReportComponent } from 'src/app/unAuthenticatedModules/HTMLFormSignReport/HTMLFormSignReport.component';

@Component({
  selector: 'app-htmlReport3c',
  templateUrl: './htmlReport3c.component.html',
  styleUrls: ['./htmlReport3c.component.scss']
})
export class HtmlReport3cComponent implements OnInit {
  organizationId: string;
  databaseId: string;
  currentUser: any;
  responseHolder: any;
  OfficeIDList: any=[];
  myOfficeID: any;

  @Input() mainModulename: string;
 
  getTagListResponseHolder: any;
  All3CEmailList:any=[]=[];
  FormFolderReportList:any=[]=[];
  FormFolderReportListReports:any=[]=[];
  indexExpanded: number;
  list: boolean = false;
  grid: boolean = true;  
  step = 0;
  datatable:any=[]=[];
  noRecordFound:boolean = false; 
  htmlData:boolean = false; 
  // FormFolderReportList1= {
  //   "data": {
  //     "formReportFolders": [
  //       {
  //         "folderID": 2,
  //         "folderName": "Demo",
  //         "position": 0,
  //         "forms": [
  //           {
  //             "mappingID": 11,
  //             "formID": 296,
  //             "formName": "web Form4",
  //             "formIcon": "3d_rotation",
  //             "formAlias": "test",
  //             "position": 2,
  //             "folderID": 2,
  //             "webFormData": []
  //           }
  //         ]
  //       },
  //       {
  //         "folderID": 6,
  //         "folderName": "Test",
  //         "position": 0,
  //         "forms": [
  //           {
  //             "mappingID": 12,
  //             "formID": 299,
  //             "formName": "QuickADT",
  //             "formIcon": "ac_unit",
  //             "formAlias": "asd",
  //             "position": 1,
  //             "folderID": 6,
  //             "webFormData": []
  //           }
  //         ]
  //       },
  //       {
  //         "folderID": 13,
  //         "folderName": "Test7",
  //         "position": 0,
  //         "forms": [
  //           {
  //             "mappingID": 13,
  //             "formID": 287,
  //             "formName": "Form 45",
  //             "formIcon": "account_balance",
  //             "formAlias": "Sign",
  //             "position": 3,
  //             "folderID": 13,
  //             "webFormData": []
  //           },
  //           {
  //             "mappingID": 18,
  //             "formID": 300,
  //             "formName": "WebForm7",
  //             "formIcon": "adb",
  //             "formAlias": "trr",
  //             "position": 4,
  //             "folderID": 13,
  //             "webFormData": [
  //               {
  //                 "formID": 300,
  //                 "jsonData": "[{\"id\":\"TextSingle-1724648802577\",\"fieldId\":0,\"name\":\"\",\"value\":\"qqqq\",\"ctrlType\":\"text\",\"folderID\":0,\"folderName\":\"\",\"fieldTypeName\":\"TextSingle\",\"isShowListing\":true},{\"id\":\"Textbox-1724648804087\",\"fieldId\":0,\"name\":\"\",\"value\":\"qwe45\",\"ctrlType\":\"text\",\"folderID\":0,\"folderName\":\"\",\"fieldTypeName\":\"Textbox\",\"isShowListing\":false}]",
  //                 "submitBy": "jenny@mailinator.com",
  //                 "checkInDate": "",
  //                 "checkOutDate": "",
  //                 "createdOn": "2024-08-27T05:57:43.6906829"
  //               },
  //               {
  //                 "formID": 300,
  //                 "jsonData": "[{\"id\":\"TextSingle-1724648802577\",\"fieldId\":0,\"name\":\"\",\"value\":\"qqqq\",\"ctrlType\":\"text\",\"folderID\":0,\"folderName\":\"\",\"fieldTypeName\":\"TextSingle\",\"isShowListing\":true},{\"id\":\"Textbox-1724648804087\",\"fieldId\":0,\"name\":\"\",\"value\":\"123\",\"ctrlType\":\"text\",\"folderID\":0,\"folderName\":\"\",\"fieldTypeName\":\"Textbox\",\"isShowListing\":false}]",
  //                 "submitBy": "",
  //                 "checkInDate": "",
  //                 "checkOutDate": "",
  //                 "createdOn": "2024-08-26T11:11:36.0368389"
  //               }
  //             ]
  //           }
  //         ]
  //       }
  //     ]
  //   },
    
  // }

  dataForPriview:any=[]=[];
  constructor(private dialog: MatDialog,private taskService: SettingService,
    private statusConst: StatusConstant, private encryptionAlgo: EncryptionService,
    private reusableClass: ReusableClasses,private loaderService: LoaderService,
    private toastr: ToastrService,private _dataSharingService: DataSharingService) {
      const encryptedtoken = sessionStorage.getItem('userToken');
      this.databaseId = sessionStorage.getItem('databaseId');
      this.organizationId = sessionStorage.getItem('organizationID');
      const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey,encryptedtoken);   
      this.currentUser = jwt_decode(token); 
      var offices=JSON.parse(sessionStorage.getItem('officeList'));
      offices.forEach(oe => {
      this.OfficeIDList.push(oe.officeID);
      if(oe.isMyoffice==true)
        this.myOfficeID=oe.officeID;
      }); 
   }

  ngOnInit(): void {
    this.taskService.openFormReportTrigger.subscribe(value => {
      if(value != null){
        this.getFormReports3C();
      }
    });
   // this.getFormReports3C();
    // this.FormFolderReportList=this.FormFolderReportList1.data.formReportFolders;

    // if (this.FormFolderReportList.length > 0) {
    //   this.FormFolderReportList.forEach(folder => {
    //     if (folder.forms.length > 0) {
    //       folder.forms.forEach(form => {
    //         form.datatable=[];
    //         if (form.webFormData.length > 0) {             
    //           form.webFormData.forEach(webData => {
    //             const jsonData = JSON.parse(webData.jsonData).filter(x => x.isShowListing !== true);
    
    //             // Add User Data to jsonData
    //             const userData = {
    //               ctrlType: "text",
    //               id: "UserName",
    //               name: "Submitted By",
    //               value: webData.submitBy,
    //             };
    //             jsonData.unshift(userData);
    
    //             jsonData.forEach(data => {
    //               let value = data.value ? data.value : "-";
    //               let fileName = (data.name === "File" && data.type === "image") ? data.FileName : "";
    
    //               const existingData = form.datatable.find(x => x.id === data.id);
    //              // const existingData = this.datatable.find(x => x.id === data.id);
    //               if (existingData) {
    //                 existingData.value.push(value);
    //               } else {
    //                 const type = data.id.split('-')[0] || "";
    
    //                 const newEntry = {
    //                   columnName: data.name,
    //                   type: type,
    //                   id: data.id,
    //                   value: [value],
    //                   FileName: fileName,
    //                 };
    
    //                 form.datatable.push(newEntry);
    //               }
    //             });
    //           });
    //         }
    //       });
    //     }
    //   });
    // }

    // this.FormFolderReportList;

    // if(this.FormFolderReportList.length>0){
    //   this.FormFolderReportList.forEach(e => {
    //     if (e.forms.length > 0) {
    //       e.forms.forEach(ee => {
    //         //if (ee.webFormData.length>0) {
    //           if(ee.webFormData.length>0){
    //             for (var i = 0, len = ee.webFormData.length; i < len; ++i) {
    //               var jsonData = [];
    //               var UserData={
    //                 ctrlType: "text",
    //                 id: "UserName",
    //                 name: "Submited By",
    //                 value: ee.webFormData[i].submitBy,
    //               }
    //               jsonData = JSON.parse(ee.webFormData[i].jsonData);
    //               jsonData = jsonData.filter(x=> x.isShowListing!=true);
    //               jsonData.splice(0, 0, UserData); 
    //               for (var i1 = 0, len1 = jsonData.length; i1 < len1; ++i1) {
    //                 var value="";
    //                 var check=[];
    //                 check = this.datatable.filter(x=>x.id == jsonData[i1].id);
    //                 if(check.length>0){
    //                   if(jsonData[i1].value!=""){
    //                     value=jsonData[i1].value;
    //                   }else{
    //                     value="-";
    //                   }
    //                   var FileName="";
    //                   if(jsonData[i1].name=="File" && jsonData[i1].type=="image"){
    //                     FileName = jsonData[i1].FileName;              
    //                   }else{
    //                     FileName ="";            
    //                   }
    //                   this.datatable.find(x => x.id == jsonData[i1].id).value.push(value);               
    //                 }else{
    //                   if(jsonData[i1].value!=""){
    //                     value=jsonData[i1].value;
    //                   }else{
    //                     value="-";
    //                   }
                     
    //                   var FileName="";
    //                   if(jsonData[i1].name=="File" && jsonData[i1].type=="image"){
    //                     FileName = jsonData[i1].FileName;              
    //                   }else{
    //                     FileName ="";            
    //                   }
                    
    //                   var type="";
    //                   var checkType= jsonData[i1].id.split('-');
    //                   if(checkType.length>0){
    //                     type = checkType[0];
    //                   }else{
    //                     type = checkType
    //                   }            
  
                      
    //                   var req = {
    //                     columnName: jsonData[i1].name,
    //                     type: type,//jsonData[i1].type,
    //                     id: jsonData[i1].id,
    //                     value: [value],
    //                     FileName: FileName,            
    //                   }          
    //                   ee.datatable.push(req);
    //                 }              
    //                }            
    //              }
    //           } else{
    //             this.noRecordFound=true;
    //          }  
    //           //ee.datatable=
    //          // ee.participantName = name;
    //        // }
    //       });
    //     }
    //   });
    // }
   
    // if(this.FormFolderReportList.length>0){
    //   this.FormFolderReportList.forEach(e => {
    //     if (e.forms.length>0) {
         
    //     }
    //   });

    //   // for (let i = 0; i < this.FormFolderReportList.length; i++) {
    //   //  var formsList:any=[]=[];
    //   //  formsList = this.FormFolderReportList[i].forms;
    //   //  if(formsList.length>0){

    //   //  }
    //   // }
    // }
   // this.getActivityEMails3C();
  }

   // get Form Report List
   getFormReports3C() {
    var cType=0;
    if(this.mainModulename=="Core"){
      cType=1;
    }
    if(this.mainModulename=="Contact"){
      cType=2;
    }
    if(this.mainModulename=="Company"){
      cType=3;
    }
    var ReqModel={
      cid:Number(sessionStorage.getItem('transactionID')),      
      cType:cType,
      userID:this.currentUser.UID,
      organizationID:Number(this.organizationId),
      officeID: this.myOfficeID,
      databaseId:Number(this.databaseId)      
     }
     this.loaderService.show();
     this.taskService.getWebFormReportFor3C(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.getTagListResponseHolder = response;
        this.loaderService.hide();
        if (this.getTagListResponseHolder.status == this.statusConst.statusSuccess) {          
          this.FormFolderReportList=this.getTagListResponseHolder.data.formReportFolders;
          this.FormFolderReportListReports=this.getTagListResponseHolder.data.formReportFolders;

          if(this.FormFolderReportList==null){
            this.FormFolderReportList=[];
            this.FormFolderReportListReports=[];
          }
         if (this.FormFolderReportList.length > 0) {
         this.FormFolderReportList.forEach(folder => {
         if (folder.forms.length > 0) {
          folder.forms.forEach(form => {
            form.datatable=[];
            if (form.webFormData.length > 0) {             
              form.webFormData.forEach(webData => {
                const jsonData = JSON.parse(webData.jsonData).filter(x => x.isShowListing !== true);
    
                // Add User Data to jsonData
                const userData = {
                  ctrlType: "text",
                  id: "UserName",
                  name: "Submitted By",
                  value: webData.submitBy,
                };
                jsonData.unshift(userData);
    
                jsonData.forEach(data => {
                  let value = data.value ? data.value : "-";
                  let fileName = (data.name === "File" && data.type === "image") ? data.FileName : "";
    
                  const existingData = form.datatable.find(x => x.id === data.id);
                 // const existingData = this.datatable.find(x => x.id === data.id);
                  if (existingData) {
                    existingData.value.push(value);
                  } else {
                    const type = data.id.split('-')[0] || "";
    
                    const newEntry = {
                      columnName: data.name,
                      type: type,
                      id: data.id,
                      value: [value],
                      FileName: fileName,
                    };
    
                    form.datatable.push(newEntry);
                  }
                });
              });
            }
          });
        }
      });
        }
        }
        else {
          this.FormFolderReportList=[];
          this.loaderService.hide();    
        }
      }else{
        this.FormFolderReportList=[];
        this.loaderService.hide();
      }
    });
  }

  togglePanels(index: number) {
    sessionStorage.setItem('currentCoreTabIndex', `${index}`);
    this.indexExpanded = index;
    //== this.indexExpanded ? 0 : index;
  }

  DownloadFile(record:any,row:any) {
    if (record !== undefined && record !== null) {
      const data = record;//'data:' + record.FileExtention + ';base64,' + record.base64URL;
      FileSaver.saveAs(data, row.FileName);
    }else{
      this.toastr.error('File download failed.', '', {
        timeOut: 3000,
      });
    }
  }

  CloseHTMLData(message:boolean){ 
    this.dialog.closeAll();
    // this.formName="";
      this.datatable=[];
    // this.noRecordFound=false;
    // this.getCloseHtmlData.emit(message);
    // this._dataSharingService.sendSelectedHTMLDataForCore(null);
 } 
 
 //@Output() getCloseHtmlData = new EventEmitter<boolean>();  

 getCloseHtmlData(closeShare: boolean) {
  this.htmlData = false;
}
  openHtmlData(document) {
    //this.htmlData=true;
    var ReqModel = {      
      transactionID: 0,
      placeholderID: 0,
      FormReportShow :true,
      reportData:document
    }
    if(this.mainModulename=="Core"){
      this._dataSharingService.sendSelectedHTMLDataForCore(ReqModel);
    }
    if(this.mainModulename=="Contact"){
      this._dataSharingService.sendSelectedHTMLDataForContact(ReqModel);
    }
    if(this.mainModulename=="Company"){
      this._dataSharingService.sendSelectedHTMLDataForCompany(ReqModel);
    }   
    //this.htmlData.emit(message);
  }

  viewHTMLData(item: any, index: number,folder:any,document:any) {
        // Check if dataForPriview exists and has items
        var documentReports:any=[];
        documentReports = document.webFormData;
        if (!documentReports || documentReports.length <= index) {
          this.toastr.warning('No Preview available for selected record.', '', {
           timeOut: 3000,
          });  
          return;
        }
      
        // Get the selected data
        const selectedData = documentReports[index];
      
        // If filledJsonData is null or undefined, stop execution
        if (!selectedData || !selectedData.filledJsonData) {      
          this.toastr.warning('No Preview available for selected record.', '', {
           timeOut: 3000,
          });  
          return;
        }
      
        // Open dialog only if valid data exists
        const dialogRef = this.dialog.open(HTMLFormSignReportComponent, {
          data: {
            htmldata: selectedData.filledJsonData,
          },
          width: '100vw',
          height: '80vh',
          panelClass: 'custom-dialog-container'
        });
      
        dialogRef.afterClosed().subscribe(result => {
          if (result != null && result != undefined) {     
          }
        });
       }
       
}
